import request from '@/utils/request.js';

const ACTIVITY_LANDING_PAGE_URL = '/v1/activity_landing_page';
const WX_AUTH_TOKEN_FALLBACK_KEY = 'wx_auth_token_fallback';

const getStorageValue = (storage, key) => {
  try {
    return storage.getItem(key) || '';
  } catch (error) {
    return '';
  }
};

// 承接页 iOS 授权硬跳后，token 可能先落在 session 兜底里；这里仅给承接页接口补请求头。
const getActivityLandingAuthHeaders = () => ({
  token: getStorageValue(localStorage, 'access_token') || getStorageValue(sessionStorage, WX_AUTH_TOKEN_FALLBACK_KEY),
});

const withActivityLandingAuth = (options) => ({
  ...options,
  headers: {
    ...(options.headers || {}),
    ...getActivityLandingAuthHeaders(),
  },
});

// 承接页旧配置接口，保留现有调用。
export const getActivityLandingConfig = (params) =>
  request({ url: '/v1/activity_landing/config', method: 'get', params, showToast: true });

// 承接页用户信息接口：获取承接页配置、当前微信用户、绑定状态和活动分发信息。
// params: { hash_id, landing_page_token }
export const getActivityLandingUserInfo = (params) =>
  request(withActivityLandingAuth({
    url: `${ACTIVITY_LANDING_PAGE_URL}/user_info`,
    method: 'get',
    params,
    showToast: true,
  }));

// 发送手机号验证码：承接页内手机号校验前先调用。
// data: { hash_id, mobile }
export const sendActivityLandingMobileCode = (data) =>
  request(withActivityLandingAuth({
    url: `${ACTIVITY_LANDING_PAGE_URL}/mobile/send_code`,
    method: 'post',
    data,
    showToast: true,
  }));

// 账号密码绑定/校验：校验成功后按 need_bind_role 决定是否还需要选择角色。
// data: { hash_id, account, password, user_id }
export const bindActivityLandingAccount = (data) =>
  request(withActivityLandingAuth({
    url: `${ACTIVITY_LANDING_PAGE_URL}/account/bind`,
    method: 'post',
    data,
    showToast: true,
  }));

// 手机号验证码绑定/校验：校验成功后按 need_bind_role 决定是否还需要选择角色。
// data: { hash_id, mobile, code }
export const bindActivityLandingMobile = (data) =>
  request(withActivityLandingAuth({
    url: `${ACTIVITY_LANDING_PAGE_URL}/mobile/bind`,
    method: 'post',
    data,
    showToast: true,
  }));

// 绑定承接页角色：账号校验后，前端选择区服角色再完成最终绑定。
// data: { hash_id, user_id, account, role_id, server_id, role_name, server_name, app_key }
export const bindActivityLandingRole = (data) =>
  request(withActivityLandingAuth({
    url: `${ACTIVITY_LANDING_PAGE_URL}/role/bind`,
    method: 'post',
    data,
    showToast: true,
  }));

// 获取承接页可绑定的区服角色列表。
// data: { hash_id, user_id }
export const getActivityLandingRoleList = (data) =>
  request(withActivityLandingAuth({
    url: `${ACTIVITY_LANDING_PAGE_URL}/role/list`,
    method: 'post',
    data,
    showToast: true,
  }));
